import { lazy } from "react";

import type { RouteConfig } from "../config";
import { ROUTES } from "../paths";

const PurchaseApprovalsPage = lazy(() =>
  import("@/pages/financial/purchase-approvals-page").then((m) => ({ default: m.PurchaseApprovalsPage }))
);
const TreasuryPage = lazy(() =>
  import("@/pages/financial/treasury-page").then((m) => ({ default: m.TreasuryPage }))
);
const FinancialDocumentsPage = lazy(() =>
  import("@/pages/financial/documents-page").then((m) => ({ default: m.FinancialDocumentsPage }))
);

const PURCHASE_REQUESTS_READ = { access: "permission" as const, entity: "purchase_requests", action: "READ" };
const TREASURY_READ = { access: "permission" as const, entity: "treasury", action: "READ" };
const FINANCIAL_DOCUMENTS_READ = { access: "permission" as const, entity: "financial_documents", action: "READ" };

export const financialRoutes: RouteConfig[] = [
  { path: ROUTES.FINANCIAL.PURCHASE_APPROVALS, component: PurchaseApprovalsPage, layout: "dashboard", permissions: PURCHASE_REQUESTS_READ },
  { path: ROUTES.FINANCIAL.TREASURY, component: TreasuryPage, layout: "dashboard", permissions: TREASURY_READ },
  { path: ROUTES.FINANCIAL.DOCUMENTS, component: FinancialDocumentsPage, layout: "dashboard", permissions: FINANCIAL_DOCUMENTS_READ },
];
